
import FacebookLoginCard from '@/components/facebook/FacebookLoginCard.vue';
import FacebookMessengerSettingsCard from '@/components/facebook/FacebookMessengerSettingsCard.vue';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Bot, FacebookMessengerPlatformData, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-platform-facebook-messenger',
  components: { FacebookLoginCard, FacebookMessengerSettingsCard },
})
export default class ProjectPlatformFacebookMessenger extends mixins(ProjectViewMixin) {
  onConnect(data: Partial<FacebookMessengerPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.FacebookMessenger]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.FacebookMessenger]: {
          pageId: '',
          pageName: '',
          pageAccessToken: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }
}
